import {
  AfterViewInit,
  ChangeDetectorRef,
  Component,
  inject,
  OnDestroy,
  OnInit,
  Renderer2,
  TemplateRef
} from '@angular/core'
import { environment } from '../../../../../environments/environment'
import { CommonModule, NgIf, NgIfContext } from '@angular/common'
import { AddSpacePipe } from '../../../../pipes/add-space.pipe'
import { CapitalizePipe } from '../../../../pipes/capitalize.pipe'
import { Store } from '@ngrx/store'
import { logout, revertSwitchUser } from '../../../../store/auth/auth.actions'
import { selectUser } from '../../../../store/auth/auth.selectors'
import {
  catchError,
  filter,
  interval,
  map,
  Observable,
  of,
  shareReplay,
  startWith,
  Subject,
  switchMap,
  take,
  takeUntil,
  tap
} from 'rxjs'
import { AuthState, selectSubscription } from '../../../../store/auth/auth.state'
import { DomSanitizer, SafeUrl } from '@angular/platform-browser'
import { HttpClient } from '@angular/common/http'
import { ApiService } from '../../../../services/api.service'
import { AuthService } from '../../../../services/auth.service'
import { NavigationEnd, Router, RouterModule } from '@angular/router'
import { eps } from '../../../../services/url.service'
import { SubscriptionStatus } from '../../../../services/subscriptions'
import { User } from '../../../../store/user/user.state'
import { loadEmployeeById$ } from '../../../../store/user/user.effects'
import { NotificationService } from '../../../../services/notification.service'
import { AlertService, AlertType } from '../../../../shared/alert.service'
import { ApiCancelService } from '../../../../services/api-cancel.service'
import { FirebaseService } from '../../../../services/firebase.service'
// import * as bootstrap from 'bootstrap'

export interface AppNotification {
  id: string
  title: string
  message: string
  createdAt: string | Date
  isRead: boolean
}

@Component({
  selector: 'app-app-header',
  imports: [NgIf, CommonModule, AddSpacePipe, CapitalizePipe, RouterModule],
  templateUrl: './app-header.component.html',
  styleUrl: './app-header.component.scss'
})
export class AppHeaderComponent implements OnInit, OnDestroy {
  public apiEndpoint = environment.apiBaseUrl
  private router = inject(Router)
  employee$: Observable<User | undefined> = of(undefined) // Initialize with a default value
  employeeImages: { [key: string]: string } = {} // Ensure this is defined correctly
  // public profilePicture = '../../../../assets/img/user.jpg'
  // public businessPicture = '../../../../assets/img/user.jpg'

  subscription$!: Observable<AuthState['subscription']>
  subscriptionStatus: string | null = null
  trialDaysRemaining: number | null = null
  trialMessage: string | null = null
  private destroy$ = new Subject<void>()
  employee: any
  loading: any
  // isOwner: string | boolean | null
  eps = eps
  notifications: AppNotification[] = []
  isNotificationsLoading = false
  private lastAlertKey: string | null = null
  showBusinessInitials = false
  isImpersonating = localStorage.getItem('isImpersonating') == 'true'

  constructor(
    private store: Store,
    private sanitizer: DomSanitizer,
    private http: HttpClient,
    private apiService: ApiService,
    private authService: AuthService,
    private renderer: Renderer2,
    private notificationService: NotificationService,
    private alertService: AlertService,
    private cdr: ChangeDetectorRef,
    private apiCancelService: ApiCancelService,
    private firebaseService: FirebaseService
  ) {
    this.store
      .select(selectUser)
      .pipe(takeUntil(this.destroy$))
      .subscribe(user => {
        this.user = user ?? null
        this.showBusinessInitials = !user?.business?.picture

        if (user?.picture) {
          const imageUrl = `${this.apiEndpoint}/uploads/${user.picture}`

          this.authService.getImage(imageUrl).subscribe({
            next: imageBlob => {
              // revoke old object URL to avoid memory leak
              if (this.userimageObjectURL) {
                URL.revokeObjectURL(this.userimageObjectURL)
              }

              this.userimageObjectURL = URL.createObjectURL(imageBlob)
              this.userPicture = this.userimageObjectURL
              // this.store.dispatch(loadEmployeeById$())
            },
            error: err => {
              console.error('Error fetching image:', err)
              // this.userPicture = this.profilePicture
            }
          })
        } else {
          // this.userPicture = this.profilePicture
        }
      })
    // this.store
    //   .select(selectUser)
    //   .pipe(
    //     takeUntil(this.destroy$),
    //     filter(user => !!user),
    //     tap(user => {
    //       this.user = user ?? null
    //     }),
    //     switchMap(user => {
    //       if (!user) return of([])
    //       return this.getNotifications(user.id)
    //     })
    //   )
    //   .subscribe(res => {
    //     this.notifications = res
    //   })

    this.subscription$ = this.store.select(selectSubscription)
    // this.subscription$
    //   .pipe(
    //     takeUntil(this.destroy$),
    //     tap(sub => (this.subscriptionStatus = sub?.subscriptionStatus ?? null))
    //   )
    //   .subscribe()
    this.subscription$
      .pipe(
        takeUntil(this.destroy$),
        tap(sub => {
          this.subscriptionStatus = sub?.subscriptionStatus ?? null
          // console.log('expiry date', sub?.expiryDate)
          // console.log('isowner', this.isOwner)
          if (
            sub?.subscriptionStatus === SubscriptionStatus.Trialing &&
            sub.expiryDate &&
            this.isOwner
          ) {
            const today = new Date()
            const trialEnd = new Date(sub.expiryDate)

            // Calculate remaining days
            const remainingDays = Math.max(
              0,
              Math.ceil((trialEnd.getTime() - today.getTime()) / (1000 * 60 * 60 * 24))
            )
            this.trialDaysRemaining = remainingDays

            // Update the message to show in HTML
            if (remainingDays > 1 && this.isOwner) {
              this.trialMessage = `You have ${remainingDays} days remaining in your trial.`
              // this.alertService.show(`You have ${remainingDays} days remaining in your trial.`)
              this.triggerOnce('trial-expire', this.trialMessage, 'danger')
              // console.log('tiral message', this.trialMessage)
            } else if (remainingDays === 1 && this.isOwner) {
              this.trialMessage = `This is the last day of your trial subscription.`
              // this.alertService.show(`This is the last day of your trial subscription.`)
              this.triggerOnce('trial-expire', this.trialMessage, 'danger')
            } else if (this.isOwner) {
              this.trialMessage = `Activate your subscription! Your trial subscription has expired.`
              // this.alertService.show(`Your trial subscription has expired.`)
              this.triggerOnce('trial-expire', this.trialMessage, 'danger')
            }
          } else if (
            sub?.trialDays &&
            this.isOwner &&
            sub.trialDays > 0 &&
            sub?.subscriptionStatus === SubscriptionStatus.Trialing
          ) {
            this.trialMessage = `You have a trial subscription for ${sub.trialDays} days.`
            this.trialDaysRemaining = null
            // this.alertService.show(`You have a trial subscription for ${sub.trialDays} days.`)
            this.triggerOnce('trial-expire', this.trialMessage, 'danger')
          } else if (
            sub?.trialDays &&
            this.isOwner &&
            sub.trialDays <= 0 &&
            sub?.subscriptionStatus !== SubscriptionStatus.Upgraded &&
            sub?.subscriptionStatus !== SubscriptionStatus.Active
          ) {
            this.trialMessage = `Your subscription has expired.`
            this.trialDaysRemaining = null
            // this.alertService.show(`You have a trial subscription for ${sub.trialDays} days.`)
            this.triggerOnce('trial-expire', this.trialMessage, 'danger')
          } else {
            this.trialMessage = null
            this.trialDaysRemaining = null
          }
        })
      )
      .subscribe()
  }

  user: AuthState['user'] | null = null
  userPicture: string | SafeUrl | null = null
  userimageObjectURL!: string | null
  user$!: Observable<any>
  ngOnInit(): void {
    this.user$ = this.store.select(selectUser)
    this.store
      .select(selectUser)
      .pipe(takeUntil(this.destroy$))
      .subscribe(user => {
        this.user = user ?? null
        this.showBusinessInitials = !user?.business?.picture

        if (user?.picture) {
          const imageUrl = `${this.apiEndpoint}/uploads/${user.picture}`

          this.authService.getImage(imageUrl).subscribe({
            next: imageBlob => {
              // revoke old object URL to avoid memory leak
              if (this.userimageObjectURL) {
                URL.revokeObjectURL(this.userimageObjectURL)
              }

              this.userimageObjectURL = URL.createObjectURL(imageBlob)
              this.userPicture = this.userimageObjectURL
              // this.store.dispatch(loadEmployeeById$())
            },
            error: err => {
              console.error('Error fetching image:', err)
              // this.userPicture = this.profilePicture
            }
          })
        } else {
          // this.userPicture = this.profilePicture
        }
      })
    // this.store
    //   .select(selectUser)
    //   .pipe(
    //     takeUntil(this.destroy$),
    //     filter(user => !!user),
    //     tap(user => {
    //       this.user = user ?? null
    //     }),
    //     switchMap(user => {
    //       if (!user) return of([])
    //       return this.getNotifications(user.id)
    //     })
    //   )
    //   .subscribe(res => {
    //     this.notifications = res
    //   })
    // this.store
    //   .select(selectUser)
    //   .pipe(
    //     takeUntil(this.destroy$),
    //     filter(user => !!user),
    //     switchMap(user =>
    //       interval(10000).pipe(
    //         startWith(0),
    //         switchMap(() => this.getNotifications(user.id)),
    //         takeUntil(this.destroy$)
    //       )
    //     )
    //   )
    //   .subscribe(res => {
    //     this.notifications = res
    //   })

    // this.store
    //   .select(selectUser)
    //   .pipe(
    //     takeUntil(this.destroy$),
    //     filter(user => !!user),
    //     switchMap(user => this.getNotifications(user.id))
    //   )
    //   .subscribe(res => {
    //     this.notifications = res
    //   })

    // this.store
    //   .select(selectUser)
    //   .pipe(
    //     takeUntil(this.destroy$),
    //     filter(user => !!user),
    //     switchMap(user =>
    //       interval(600000).pipe(
    //         startWith(0),
    //         switchMap(() => this.getNotifications(user.id)),
    //         takeUntil(this.destroy$)
    //       )
    //     )
    //   )
    //   .subscribe(res => {
    //     this.notifications = res
    //     this.cdr.detectChanges()
    //   })

    this.store
      .select(selectUser)
      .pipe(
        takeUntil(this.destroy$),
        filter(user => !!user),
        take(1),
        switchMap(user => this.getNotifications(user.id))
      )
      .subscribe(res => {
        this.notifications = res
        this.cdr.detectChanges()
      })

    // Push notification
    this.firebaseService.newNotification$
      .pipe(
        takeUntil(this.destroy$),
        switchMap(() => {
          const id = this.user?.id
          return id ? this.getNotifications(id) : of([])
        })
      )
      .subscribe(res => {
        if (res.length || this.notifications.length) {
          this.notifications = res
          this.cdr.detectChanges()
        }
      })

    // Re-fetch on every navigation — clears bell dot after isRead=true happened elsewhere
    this.router.events
      .pipe(
        filter(event => event instanceof NavigationEnd),
        takeUntil(this.destroy$),
        switchMap(() => {
          const id = this.user?.id
          return id ? this.getNotifications(id) : of([])
        })
      )
      .subscribe(res => {
        this.notifications = res
        this.cdr.detectChanges()
      })
  }

  ngOnDestroy(): void {
    this.destroy$.next()
    this.destroy$.complete()

    if (this.userimageObjectURL) {
      URL.revokeObjectURL(this.userimageObjectURL)
    }
  }

  // logout() {
  //   this.alertService.clear() // ✅ add this
  //   // Cancel pending requests and block new protected requests
  //   this.apiCancelService.startLogout()
  //   this.store.dispatch(logout())
  // }

  logout() {
    this.alertService.clear()

    const accessToken = localStorage.getItem('accessToken')
    console.log('access token', accessToken)
    if (!accessToken) {
      this.finishLogout()
      return
    }

    this.apiCancelService.startLogoutApi()

    this.authService.logout(accessToken).subscribe({
      next: () => this.finishLogout(),
      error: () => this.finishLogout()
    })
  }

  private finishLogout() {
    this.apiCancelService.endLogoutApi()
    this.apiCancelService.startLogout() // pending requests cancel
    this.store.dispatch(logout()) // अब token/state clear
    this.router.navigate([eps.auth.loginPath])
  }

  checkImage(url: string): void {
    this.http.get(url, { responseType: 'blob' }).subscribe(
      response => {
        console.log('Image is accessible:', response)
      },
      error => {
        console.error('Image access error:', error)
      }
    )
  }

  getSanitizedImageUrl(imageUrl: string): SafeUrl {
    return this.sanitizer.bypassSecurityTrustUrl(imageUrl)
  }

  getInitials(firstName?: string | null, lastName?: string | null): string {
    const f = (firstName ?? '').trim()
    const l = (lastName ?? '').trim()
    if (!l && f.includes(' ')) {
      const parts = f.split(/\s+/)
      return `${parts[0].charAt(0)}${parts[parts.length - 1].charAt(0)}`.toUpperCase()
    }
    return `${f.charAt(0)}${l.charAt(0)}`.toUpperCase()
  }

  // getDashboardRoute(): string {
  //   const isAdmin = this.user?.userRoles?.some(ur => ur.role.name === 'Admin')
  //   return isAdmin ? eps.dashboardPath : eps.employeeDashboardPath
  // }

  getDashboardRoute(): string {
    // Check if any role in userRoles array has the name 'Admin'console.log('user', this.user?.userRoles)
    const isAdmin = this.user?.userRoles?.some(ur => ur.role?.name === 'Admin')
    return isAdmin ? eps.dashboardPath : eps.employeeDashboardPath
  }

  // toggleSidebar(): void {
  //   const mainWrapper = document.querySelector('.main-wrapper')

  //   if (mainWrapper?.classList.contains('slide-nav')) {
  //     this.renderer.removeClass(mainWrapper, 'slide-nav')
  //   } else {
  //     this.renderer.addClass(mainWrapper, 'slide-nav')
  //   }
  // }
  toggleSidebar(event: Event): void {
    event.stopPropagation() // 🔥 prevents HostListener firing

    const mainWrapper = document.querySelector('.main-wrapper')

    if (mainWrapper?.classList.contains('slide-nav')) {
      this.renderer.removeClass(mainWrapper, 'slide-nav')
    } else {
      this.renderer.addClass(mainWrapper, 'slide-nav')
    }
  }

  // get isAdmin(): boolean {
  //   return this.user?.userRoles?.some((ur: any) => ur.role?.name === 'Admin') ?? false
  //   // return this.user?.role === 'Admin'
  // }

  get isOwner(): boolean {
    // console.log('user', this.user)
    return this.user?.userRoles?.some((ur: any) => ur.role?.name === 'Business Owner')
      ? true
      : this.user?.employmentType === 'Business Owner'
        ? true
        : false
    // return this.user?.role === 'Admin'
  }

  get isAdmin(): boolean {
    return this.user?.userRoles?.some((ur: any) => ur?.role === 'Admin') ?? false
  }
  redirectToBilling() {
    this.router.navigate([eps.planAndBilling.planPath])
  }

  get showActivationLink(): boolean {
    return !this.isAdmin && this.isOwner && this.subscriptionStatus === SubscriptionStatus.Trialing
  }
  getNotifications(userId: string): Observable<AppNotification[]> {
    const search = ''
    const page = 1
    const limit = 5

    return this.notificationService.list(userId, search, page, limit).pipe(
      map(res =>
        (res.notifications || []).map((n: AppNotification) => ({
          ...n,
          createdAt: new Date(n.createdAt)
        }))
      ),
      catchError(err => {
        console.error('Failed to fetch notifications:', err)
        return of([])
      }),
      shareReplay(1)
    )
  }

  handleNotificationClick(notification: AppNotification) {
    // console.log('Clicked notification:', notification)
    if (!notification.isRead) {
      this.notificationService.markAsRead(notification.id).subscribe({
        next: () => {
          notification.isRead = true
          this.notifications = [...this.notifications]
          this.cdr.detectChanges()
        },
        error: err => console.error('Failed to mark as read:', err)
      })
    }
  }

  // triggerAlert() {
  //   this.alertService.show('Your subscription is about to expire!')
  // }

  private triggerOnce(key: string, message: string, type: AlertType) {
    if (this.lastAlertKey === key) return
    this.lastAlertKey = key

    this.alertService.show(message, type)
  }

  // ngAfterViewInit() {
  //   document.querySelectorAll('.dropdown-toggle').forEach(el => new bootstrap.Dropdown(el))
  // }

  revert() {
    this.store.dispatch(revertSwitchUser())
  }

  get hasUnreadNotifications(): boolean {
    return this.notifications.some(n => !n.isRead)
  }
}
